export const sparkedCocoMarkersDataSelector = ({sparkedCocoMarkersData}) => sparkedCocoMarkersData